import { FC } from 'react';

import { HamburgerMenuWrapper, Icon } from './styled';

export interface IHamburgerMenu {
  isOpen: boolean;
  toogleMenuOpen: () => void;
}

const HamburgerMenu: FC<IHamburgerMenu> = ({ isOpen, toogleMenuOpen }) => (
  <HamburgerMenuWrapper onClick={toogleMenuOpen}>
    <Icon isOpen={isOpen} />
  </HamburgerMenuWrapper>
);

export default HamburgerMenu;
